// Initializes the Zoho SalesIQ widget for the given user profile.
export default function initZohoSalesIQ(userProfile) {
  if (!userProfile) return;
  const existingZohoScript = document.getElementById("zsiqscript");
  if (existingZohoScript) existingZohoScript.remove();
  window.$zoho = {};
  window.$zoho.salesiq = {
    widgetcode: process.env.VUE_APP_ZOHO,
    values: {},
    ready: function () {
      // Hide Zoho's own launcher, the chat is opened from the toolbar button
      if (typeof window.$zoho.salesiq.floatbutton?.visible === "function") {
        window.$zoho.salesiq.floatbutton.visible("hide");
      }
      window.$zoho.salesiq.language(userProfile.language);
      window.$zoho.salesiq.visitor.name({
        firstname: userProfile.name,
        lastname: userProfile.surnames,
      });
      window.$zoho.salesiq.visitor.email(userProfile.username);
      window.$zoho.salesiq.visitor.id(String(userProfile.id));
      window.$zoho.salesiq.visitor.contactnumber(userProfile.phoneNumber);
      window.$zoho.salesiq.visitor.info({
        userID: userProfile.id,
        owner: userProfile.ownerPerson?.name,
        ownerID: userProfile.ownerPerson?.id,
      });
    },
  };
  const zohoScript = document.createElement("script");
  zohoScript.type = "text/javascript";
  zohoScript.id = "zsiqscript";
  // The widget code must travel in the "wc" param: the loader builds the
  // URL of its internal bundle from this src and a leading "?t=" breaks it
  zohoScript.src = `https://salesiq.zoho.eu/widget?wc=${process.env.VUE_APP_ZOHO}&t=${Date.now()}`;
  document.body.appendChild(zohoScript);
}
